import transferAccount from 'root/src/client/logic/auth/thunks/transferAccount'
import { TRANSFER_ACCOUNT_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[TRANSFER_ACCOUNT_MODULE_ID]: [
		{
			action: transferAccount,
		},
	],
}
